
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire02cb"];
var parcelRegister = parcelRequire.register;
parcelRegister("4ApZO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cd4e0e10f9e56fb$export$2e2bcd8739ae039; });

var $1dxTK = parcelRequire("1dxTK");

var $aX1RZ = parcelRequire("aX1RZ");

var $d7J1O = parcelRequire("d7J1O");
const $1cd4e0e10f9e56fb$var$Switch = ({ register: register = {}, readOnly: readOnly = false, className: className = "", required: required = false, ...props })=>{
    return /*#__PURE__*/ (0, $1dxTK.jsxs)("label", {
        className: `${$d7J1O.switch} ${readOnly ? $d7J1O.readOnly : ""} ${className}`,
        children: [
            /*#__PURE__*/ (0, $1dxTK.jsx)("input", {
                type: "checkbox",
                required: required,
                ...register,
                ...props,
                disabled: readOnly
            }),
            /*#__PURE__*/ (0, $1dxTK.jsx)("span", {
                className: $d7J1O.slider
            })
        ]
    });
};
var $1cd4e0e10f9e56fb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aX1RZ))).memo($1cd4e0e10f9e56fb$var$Switch);

});
parcelRegister("d7J1O", function(module, exports) {

$parcel$export(module.exports, "readOnly", function () { return $98dedb7976dc646e$export$b2cbc93d4da94977; }, function (v) { return $98dedb7976dc646e$export$b2cbc93d4da94977 = v; });
$parcel$export(module.exports, "slider", function () { return $98dedb7976dc646e$export$b38bf4f33e9e4c25; }, function (v) { return $98dedb7976dc646e$export$b38bf4f33e9e4c25 = v; });
$parcel$export(module.exports, "switch", function () { return $98dedb7976dc646e$export$52002a3975269b5d; }, function (v) { return $98dedb7976dc646e$export$52002a3975269b5d = v; });
var $98dedb7976dc646e$export$b2cbc93d4da94977;
var $98dedb7976dc646e$export$b38bf4f33e9e4c25;
var $98dedb7976dc646e$export$52002a3975269b5d;
$98dedb7976dc646e$export$b2cbc93d4da94977 = `UbqDKG_readOnly`;
$98dedb7976dc646e$export$b38bf4f33e9e4c25 = `UbqDKG_slider`;
$98dedb7976dc646e$export$52002a3975269b5d = `UbqDKG_switch`;

});



//# sourceMappingURL=Experimental.30bba60e.js.map
